// Reads use server projections; writes remain independently authorized by RLS/RPCs.
const projections = new Set([
  'product_variants',
  'inventory_items',
  'stock_movements',
  'sales',
  'sale_items',
  'cash_accounts',
  'v_inventory_summary',
  'v_low_stock',
]);
const relationProjections = new Set([...projections, 'profiles']);
export function createAccessFetch(baseFetch: typeof fetch = globalThis.fetch): typeof fetch {
  return async (input, init) => {
    const originalUrl =
      typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
    const method = (
      init?.method ?? (typeof input === 'object' && 'method' in input ? input.method : 'GET')
    ).toUpperCase();
    const url = new URL(originalUrl);
    if (
      ['GET', 'HEAD'].includes(method) &&
      url.pathname.includes('/rest/v1/') &&
      !url.pathname.includes('/rpc/')
    ) {
      const table = url.pathname.split('/').pop()!;
      if (projections.has(table))
        url.pathname = url.pathname.slice(0, -table.length) + `access_${table}`;
      const select = url.searchParams.get('select');
      if (select)
        url.searchParams.set(
          'select',
          select.replace(
            /(^|[,(])\s*(\w+\s*:\s*)?(\w+)((?:\s*![\w]+)*\s*\()/g,
            (match, prefix, alias, relation, suffix) => {
              const aliasName = alias?.replace(/\s*:\s*$/, '');
              const projected = relationProjections.has(relation)
                ? relation
                : aliasName && relationProjections.has(aliasName)
                  ? aliasName
                  : undefined;
              if (!projected) return match;
              const hint = projected === relation ? '' : `!${relation}`;
              return `${prefix}${alias ?? `${relation}:`}access_${projected}${hint}${suffix}`;
            },
          ),
        );
      const next =
        typeof input === 'object' && 'url' in input
          ? new Request(url.toString(), input)
          : url.toString();
      return baseFetch(next, init);
    }
    return baseFetch(input, init);
  };
}
